import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  change(event) {
    const perPage = event.target.value
    const url = new URL(window.location.href)
    url.searchParams.set('per', perPage)
    url.searchParams.set('page', 1) // 切换容量时重置回第一页
    window.location.href = url.toString()
  }
}
